import styled from '@emotion/styled';

export default styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  color: #00000099;

  & > span {
    margin-right: 20px;
  }
`;
